/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Spaces_Remove_User_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to remove \"{email}\" from this space?" |
*
* @param {Spaces_Remove_User_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_remove_user_confirm_description = /** @type {((inputs: Spaces_Remove_User_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Remove_User_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie ${i?.email} wirklich aus diesem Space entfernen?`)
	return /** @type {LocalizedString} */ (`Are you sure you want to remove "${i?.email}" from this space?`)
});